import MinimalistDashboard from './MinimalistDashboard';

// ModernDashboard is an alias for MinimalistDashboard
// This file exists to maintain compatibility with App.tsx imports
const ModernDashboard: React.FC = () => {
  return <MinimalistDashboard />;
};

export default ModernDashboard;

